module.exports = __webpack_public_path__ + "static/newsletter-image-de267f2ae0fc54773b68d9e4ad8e8e84.svg";